D.libs = {
	reCaptcha: {},
	FB: {},
	Glide: {
		js: '/dist/vendor/glide/glide.min.js',
		css: '/dist/vendor/glide/css/glide.core.min.css'
	},
	braintree: {},
	applePay: {},
	everyPayApplePayClient: {},
	everyPayGooglePayClient: {},
};

D._onLoadNorm = function( name ){
	if( !this.libs[name] ){
		return null;
	}
	let v = this.libs[name];
	let re = {
		lib: [],
		js: [],
		css: []
	};
	if( v instanceof Function ){
		v = v();
	}
	if( typeof v === 'string' ){
		re.js = [v];
		return re;
	}
	if( !(v instanceof Object) ){
		return re;
	}
	let kws = ['js', 'css', 'lib'];
	for( let k in kws ){
		if( kws.hasOwnProperty(k) ){
			let kw = kws[k];
			if( typeof v[kw] === 'string' ){
				re[kw] = [v[kw]];
			} else if( v[kw] instanceof Array ){
				re[kw] = v[kw];
			}
		}
	}
	return re;
};

D._onLoadCheck = function( name ){
	let v = this._onLoadNorm(name);
	if( v ){
		let k;
		for( k in v.js ){
			if( v.js.hasOwnProperty(k) ){
				D.addJS(v.js[k], function(){
					setTimeout(function(){
						D.loaded();
					}, 1);
				});
			}
		}
		for( k in v.css ){
			if( v.css.hasOwnProperty(k) ){
				D.addCSS(v.css[k]);
			}
		}
		return;
	}
	if( name.substr( 0, 3 ) == 'DR.' ){
		var parts = name.toLowerCase().split('.');
		parts.shift();
		var url = '/assets/js/api/' + parts.join('/') + '.js';
		D.addJS(url);
	}
};

/**
 * @param {String} name
 * @private
 */
D._onLoadIs = function( name ){
	if( name.indexOf('.') > 0 ){
		try{
			return !!eval(name);
		} catch( e ){
		}
		return false;
	}
	return !!( D[name] || window[name] );
};

D._onLoadItem = function( item ){
	for( let name in item.libs ){
		if( item.libs.hasOwnProperty(name) ){
			if( item.libs[name] === 2 ){
				continue;
			}
			if( this._onLoadIs(name) ){
				item.libs[name] = 2;
				continue;
			}
			if( item.libs[name] === 1 ){ // in progress
				setTimeout(D.closure(this, function( name ){
					if( !D._onLoadIs(name) ){
						if( D.DEV ){
							D.log(name, 'library timed out');
						}
					}
				}, name), 5000);
				return false;
			}
			item.libs[name] = 1;
			this._onLoadCheck(name);
			return false;
		}
	}
	try{
		item.cb();
	} catch( e ){
		D.log(e);
	}
	return true;
};

D._onLoadWaiting = [];

D._onLoadAddLib = function( name, item ){
	let v = this._onLoadNorm(name);
	if( !v ){
		D.log('Unknown lib', name);
		return;
	}
	for( let j in v.lib ){
		if( v.lib.hasOwnProperty(j) ){
			D._onLoadAddLib(v.lib[j], item);
		}
	}
	item.libs[name] = 0;
};

D.onLoad = function( lib, cb ){
	let item = {
		libs: {},
		cb: cb
	};
	if( !( lib instanceof Array ) ){
		lib = [lib];
	}
	for( let k in lib ){
		if( lib.hasOwnProperty(k) ){
			let name = lib[k];
			if( this.libs[name] ){
				D._onLoadAddLib(name, item);
			} else {
				item.libs[name] = 0;
			}
		}
	}
	if( this._onLoadItem(item) ){
		return true;
	}
	this._onLoadWaiting.push(item);
	return false;
};

D.loaded = function( n ){
	if( n ){
		//D.log( 'loaded:', n );
	}
	let rm = [];
	for( let k in this._onLoadWaiting ){
		if( this._onLoadItem(this._onLoadWaiting[k]) ){
			rm.push(k);
		}
	}
	rm.reverse();
	for( let k in rm ){
		if( rm.hasOwnProperty(k) ){
			this._onLoadWaiting.splice(rm[k], 1);
		}
	}
};

D.reCaptcha = false;
D.reCaptchaLoading = false;
D.onCaptcha = function(cb){
	if( D.reCaptcha ){
		cb();
		return;
	}
	if( D.reCaptchaLoading ){
		D.onLoad('reCaptcha', cb);
		return;
	}
	D.reCaptchaLoading = true;
	window.onCaptchaReady = function(){
		D.reCaptcha = true;
		D.loaded('reCaptcha');
	};
	D.addJS('https://www.google.com/recaptcha/api.js?onload=onCaptchaReady&render=explicit&hl=' + D.LANG);
	D.onLoad('reCaptcha', cb);
};

D.FB = false;
D.FBLoading = false;
D.onFB = function(cb){
	if( D.FB ){
		cb();
		return;
	}
	if( D.FBLoading ){
		D.onLoad('FB', cb);
		return;
	}
	D.FBLoading = true;
	window.fbAsyncInit = function(){
		D.FB = true;
		FB.init({
			appId: '319956278850093',
			cookie: true,
			xfbml: true,
			version: 'v10.0'
		});
		D.loaded('FB');
	};
	(function(d, s, id){
		let js, fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) {return;}
		js = d.createElement(s); js.id = id;
		js.src = "https://connect.facebook.net/en_US/sdk.js";
		fjs.parentNode.insertBefore(js, fjs);
	}(document, 'script', 'facebook-jssdk'));
	D.onLoad('FB', cb);
};

D.braintree = false;
D.braintreeLoading = false;
D.onBraintree = function(cb){
	if( D.braintree ){
		cb();
		return;
	}
	if( D.braintreeLoading ){
		D.onLoad('braintree', cb);
		return;
	}
	D.braintreeLoading = true;
	D.addJS('https://js.braintreegateway.com/web/dropin/1.20.4/js/dropin.min.js', function(){
		D.braintree = true;
		D.loaded('braintree');
	});
	D.onLoad('braintree', cb);
};

D.applePay = false;
D.applePayLoading = false;
D.onApplePay = function(cb){
	if( D.applePay ){
		cb();
		return;
	}
	if( D.applePayLoading ){
		D.onLoad('applePay', cb);
		return;
	}
	D.applePayLoading = true;
	D.addJS('https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js', function(){
		D.applePay = true;
		D.loaded('applePay');
	});
	D.onLoad('applePay', cb);
};

D.everyPayApplePayClient = false;
D.everyPayApplePayClientLoading = false;
D.onEveryPayApplePayClient = function(cb){
	if( D.everyPayApplePayClient ){
		cb();
		return;
	}
	if( D.everyPayApplePayClientLoading ){
		D.onLoad('everyPayApplePayClient', cb);
		return;
	}
	D.everyPayApplePayClientLoading = true;
	D.addJS('https://pay.every-pay.eu/apple_pay/apple-pay-client-1.4.js', function(){
		D.everyPayApplePayClient = true;
		D.loaded('everyPayApplePayClient');
	});
	D.onLoad('everyPayApplePayClient', cb);
};

D.everyPayGooglePayClient = false;
D.everyPayGooglePayClientLoading = false;
D.onEveryPayGooglePayClient = function(cb){
	if( D.everyPayGooglePayClient ){
		cb();
		return;
	}
	if( D.everyPayGooglePayClientLoading ){
		D.onLoad('everyPayGooglePayClient', cb);
		return;
	}
	D.everyPayGooglePayClientLoading = true;
	D.addJS('https://pay.every-pay.eu/google_pay/google-pay-client-1.4.js', function(){
		D.everyPayGooglePayClient = true;
		D.loaded('everyPayGooglePayClient');
	});
	D.onLoad('everyPayGooglePayClient', cb);
};